import { Affix, Button } from 'antd';
import styles from './index.module.less';
import { useRouter } from 'next/router';
import { imgUrl } from '@/shared/utils';
import useScreenSize from '@/lib/hooks/utils/useScreenSize';
import { useTranslation } from 'next-i18next';
import { HairLibPublicModel } from '@/types/hairstyle';
import { useEffect, useState } from 'react';

import { fetchHairstyleLibRandomData } from '@/lib/service';
import UploadImageContent from '@/components/HairChangeContent/UploadImageContent';
import { useUserProvider } from '@/context/UserProvider';
const ArticleRightItemList = ({ dataList, style }: { dataList?: HairLibPublicModel[]; style?: {} }) => {
  const router = useRouter();
  const { width } = useScreenSize();
  const { t } = useTranslation();
  // 刷数据
  const [overWrite, setOverWrite] = useState<HairLibPublicModel[]>(dataList || []);
  const [libId, setLibId] = useState<any>(null);
  const { isLogin, onOpenLoginModal } = useUserProvider();
  const currentPath = router.asPath;

  useEffect(() => {
    if (dataList.length > 0) {
      return;
    }
    overWriteData(currentPath);
  }, []);

  const overWriteData = (currentPath: string) => {
    let type: string = '';
    let articleId: number = 0;
    if (currentPath.startsWith('/blog')) {
      type = 'all';
    } else if (currentPath.startsWith('/category')) {
      // 假设/category之后直接跟着gender信息，且gender由路径分隔符划分
      type = currentPath.split('/')[2];
    } else if (currentPath.startsWith('/article')) {
      // 使用正则表达式提取/article/后的数字
      const match = /\/article\/(\d+)/.exec(currentPath);
      if (match && match[1]) {
        articleId = Number(match[1]);
        type = 'article';
      }
    }
    const param = {
      articleId: articleId
    };
    fetchHairstyleLibRandomData(type, param).then((res) => {
      setOverWrite(res?.data);
    });
  };

  const getItemsData = (isBig: boolean) => {
    return (
      <>
        <h3 className={styles.title}>{t('Pick Your Hairstyles')}</h3>
        {isBig ? (
          <>
            <ul className={styles.dataListContainer}>
              {overWrite?.slice(0, 4).map((item, index) => {
                return (
                  <li key={item?.lib_id}>
                    <img src={imgUrl(item?.image_url, 'mid')} alt={item?.image_alt} />
                    <div className={styles.coverContainer}>
                      <Button className={styles.tryOnBtn} onClick={() => setLibId(item?.lib_id)}>
                        {t('Try-On')}
                      </Button>
                    </div>
                  </li>
                );
              })}
            </ul>
            {
              <Affix offsetTop={64}>
                <ul className={styles.dataListContainer}>
                  {overWrite?.slice(4, 8).map((item, index) => {
                    return (
                      <li key={item?.lib_id}>
                        <img src={imgUrl(item?.image_url, 'mid')} alt={item?.image_alt} />
                        <div className={styles.coverContainer}>
                          <Button className={styles.tryOnBtn} onClick={() => setLibId(item?.lib_id)}>
                            {t('Try-On')}
                          </Button>
                        </div>
                      </li>
                    );
                  })}
                </ul>
              </Affix>
            }
          </>
        ) : (
          <ul className={styles.dataListContainer}>
            {overWrite.map((item, index) => {
              return (
                <li key={item?.lib_id}>
                  <img src={imgUrl(item?.image_url, 'mid')} alt={item?.image_alt} />
                  <div className={styles.coverContainer}>
                    <Button
                      className={styles.tryOnBtn}
                      onClick={() => {
                        if (isLogin) {
                          setLibId(item?.lib_id);
                        } else {
                          onOpenLoginModal(true);
                        }
                      }}
                    >
                      {t('Try-On')}
                    </Button>
                  </div>
                </li>
              );
            })}
          </ul>
        )}
      </>
    );
  };

  return (
    <div className={styles.mainContainer} style={{ ...style }}>
      {getItemsData(width >= 768)}
      <UploadImageContent openId={libId} handleClose={() => setLibId(null)} />
    </div>
  );
};

export default ArticleRightItemList;
